export async function storeItem(key: string, value: string) {
  localStorage.setItem(key, value);
}

export async function retrieveItem(key: string) {
  return Promise.resolve(localStorage.getItem(key));
}
